package com.eladfinish.bible.contest.screens.browse.usecases.shonot

import com.eladfinish.bible.contest.screens.browse.tableOfContents.model.VerseReferenceCV
import com.eladfinish.bible.contest.screens.browse.usecases.GetContentUseCase
import com.eladfinish.bible.contest.utils.beautifyText

class GetTaanitTziburContentUseCase(
    private val getContentUseCase: GetContentUseCase,
) {
    operator fun invoke(): String {
        val bookIndex = 2
        val bookName = "shemot"

        val part1 = getContentUseCase.getContent(
            bookIndex = bookIndex,
            bookName = bookName,
            currentChapter = 32,
            startVerseReferenceCV = VerseReferenceCV(chapter = 32, verse = 11),
            endVerseReferenceCV = VerseReferenceCV(chapter = 32, verse = 14),
            onlyQri = true,
        )

        val part2 = getContentUseCase.getContent(
            bookIndex = bookIndex,
            bookName = bookName,
            currentChapter = 34,
            startVerseReferenceCV = VerseReferenceCV(chapter = 34, verse = 1),
            endVerseReferenceCV = VerseReferenceCV(chapter = 34, verse = 10),
            onlyQri = true,
        )

        return buildString {
            append(part1)
            append(" ")
            append(part2)
        }.beautifyText()

    }
}
